'use client'

import { useEffect, useState } from 'react'
import { Button } from '../ui/button'
import { CommandDialog, CommandInput, CommandItem, CommandList } from '../ui/command'
import useBookingSearchParams from '@/hooks/useBookingParamsHook'
import { useBookingParams } from '@/hooks/useBookingParams'
import { X } from 'lucide-react'
import { useTranslations } from 'next-intl'
import { cn } from '@/lib/utils'

const PromoCodeInput = ({
  button = false,
  disableUrlUpdate = false,
  onPromoChange,
}: {
  button?: boolean
  disableUrlUpdate?: boolean
  onPromoChange?: (promo: string | null) => void
}) => {
  const { promo: promoParam } = useBookingSearchParams()

  const t = useTranslations()

  const [open, setOpen] = useState(false)
  const [promo, setPromo] = useState<string | null>(null)
  const [appliedPromo, setAppliedPromo] = useState<string | null>(promoParam ? promoParam : null)

  const { updateParams } = useBookingParams()

  const handleValue = (value: string) => {
    setAppliedPromo(value)
    setOpen((open) => !open)
    if (disableUrlUpdate) {
      onPromoChange?.(value)
      return
    }
    updateParams((params) => params.set('promo', value))
  }

  // useEffect(() => {
  //   const down = (e: KeyboardEvent) => {
  //     if (e.key === 'Enter') {
  //       e.preventDefault()

  //       if (promo) {
  //         handleValue(promo)
  //       }
  //     }
  //   }

  //   document.addEventListener('keydown', down)
  //   return () => document.removeEventListener('keydown', down)
  // }, [promo])

  useEffect(() => {
    if (promoParam !== appliedPromo) {
      setAppliedPromo(promoParam ?? null)
    }
  }, [promoParam])

  return (
    <div className='flex flex-col items-end'>
      {appliedPromo ? (
        <div
          className={cn('flex items-center space-x-2', {
            'hover:bg-background bg-input border-secondary flex h-[50px] w-full items-center gap-2 rounded-md border px-4! py-3 transition-colors md:shadow-md':
              button,
          })}
        >
          <Button
            variant={'link'}
            className={'no-underline hover:no-underline'}
            onClick={() => setOpen(true)}
          >
            {!button && <p>{t('booking_code')}:</p>}
            {appliedPromo.toUpperCase()}
          </Button>

          <Button
            size={'icon'}
            variant={'secondary'}
            className='size-6'
            aria-label={t('remove_booking_code')}
            onClick={() => {
              setAppliedPromo(null)
              setPromo(null)
              if (disableUrlUpdate) {
                onPromoChange?.(null)
                return
              }
              updateParams((params) => params.delete('promo'))
            }}
          >
            <X className='size-4' />
          </Button>
        </div>
      ) : (
        <Button
          variant={'link'}
          onClick={() => setOpen(true)}
          className={cn('no-underline hover:no-underline', {
            'hover:bg-background bg-input border-secondary flex h-[50px] w-full items-center gap-2 rounded-md border px-4! py-3 font-normal! transition-colors md:shadow-md':
              button,
          })}
        >
          {t('add_booking_code')}
        </Button>
      )}

      {/*{appliedPromo && (
        <div className='flex items-center space-x-2'>
          <IconBadge icon={Check} className='p-1' iconClassName='size-4' />
          <p>{appliedPromo}</p>
        </div>
      )}*/}

      <CommandDialog open={open} onOpenChange={setOpen} showCloseButton={false}>
        <CommandInput
          placeholder={t('enter_booking_code')}
          autoFocus
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault()
              if (promo) {
                handleValue(promo)
              }
            }
          }}
          icon={false}
          onValueChange={(val) => setPromo(val.toUpperCase() || null)}
          value={promo?.toUpperCase() || ''}
        />
        <CommandList>
          <CommandItem className='justify-end bg-transparent!'>
            <Button className='w-full max-w-fit' onClick={() => promo && handleValue(promo)}>
              {t('add_booking_code')}
            </Button>
          </CommandItem>
        </CommandList>
      </CommandDialog>
    </div>
  )
}

export default PromoCodeInput
